import type { TransformerExtended } from "@/Common/Models/Domain/Transformer";
import type { UserProgressApi } from "@/Modules/Models/Api/User";
import type { UserProgress } from "@/Modules/Models/Domain/User";

import DefaultTransformerGenerator from "@/Common/Transformers/FunctionalBase";

import { camel } from "@/Utils/Camelize";

const UserProgressTransformer: TransformerExtended<UserProgress, UserProgressApi> = {
  ...DefaultTransformerGenerator<UserProgress, UserProgressApi>(),

  toDomain(input: UserProgressApi): UserProgress {
    return camel(input);
  },
};

export type UserProgressTransformerType = TransformerExtended<UserProgress, UserProgressApi>;

export default UserProgressTransformer;
